// django-equivalent slugify method
export const slugify = (value: string | number) => {
  value = String(value) // coerce type to string
  value = value.normalize("NFKD")
  value = value
    .replace(/[^\w\s-]/g, "")
    .trim()
    .toLowerCase()
  return value.replace(/[-\s]+/g, "-")
}

export const slugifyItem = (item: { name: string; id: number }) => {
  return `${slugify(item.name)}-${item.id}`
}
